export default {
  revenue_growth_rate: '',
  total_sales_cost: '',
  gross_margin: '',
  operating_expenses: '',
  ebitda_margin: '',
  adjusted_ebitda_margin: '',
  profit_margin: '',
};
